import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);
export const i18n = new VueI18n({
  locale: 'de',
  fallbackLocale: 'de',
  messages: {
    de: {
      home: 'Home',
      services: 'Leistungen',
      portfolio: 'Portfolio',
      about: 'Über uns',
      contact: 'Kontakt',
      references: 'Referenzen',
      jobs: 'Jobs',
      title: 'IT-Komplettlösungen aus einer Hand',
      subtitle: 'Qualifizierter 24/7 Betrieb',
      hosting: {
        title: 'Managed Hosting',
        subtitle: 'Von der E-Mail-Adresse zum redundanten HA-Cluster.',
        1: 'Hosting/Storage in der Cloud (VDI)',
        2: 'Physisch/virtuell + mixMode',
        3: 'Multisite-HA-Cluster, active/active',
        4: 'Domain-/DNS-Verwaltung, E-Mail',
      },
      support: {
        title: 'IT(K)-Support für KMU',
        subtitle: 'Speziell für kleine und mittlere Unternehmen bieten wir vielfältige Supportleistungen an.',
        1: 'Lokale Standortvernetzung',
        2: 'HW/SW-Upgrades & Patching',
        3: 'Consulting',
        4: 'Client-Support',
      },
      development: {
        title: 'Web Development',
        subtitle: 'Wir unterstützen Ihre Geschäftsprozesse mit maßgeschneiderter Software.',
        1: 'PHP, Laravel, Symfony',
        2: 'MySQL, PostgreSQL, MongoDB',
        3: 'JavaScript, Vue.js',
        4: 'HTML, CSS, Sass',
      },
      company: {
        1: 'Die bringe Informationstechnik GmbH ist ein inhabergeführtes Unternehmen, das im März 2000 gegründet wurde.',
        2: 'Am Standort Karlsruhe realisieren wir Individuallösungen im B2B-Bereich.',
        us: {
          title: 'Wer wir sind',
          1: 'ISP/ITK Systemintegrator – „Systemhaus mit angeschlossenem Datacenter“',
          2: 'ISO 27001/2013 Zertifizierung',
          3: 'B2B-Lösungen Made in Germany',
          4: 'Das Unternehmen unterliegt dem deutschen Bundesdatenschutzgesetz',
          5: '15 Mitarbeiter starkes Team',
        },
        center: {
          title: 'Unsere Datacenter',
          1: 'Komplettes Infrastrukturmanagement by bringe',
          2: 'Datacenter-Betrieb mit mehreren aktiven Standorten',
          3: 'DC-Kopplungen über disjunkte Verbindungen (> 150 G)',
          4: 'Redundante Breitband-Internetanbindung (> 30 G)',
          5: 'Direktes Peering mit mehreren Betreibern von Tier-1-Backbones',
        }
      },
      team: {
        title: 'Stärken Sie unser Team',
        subtitle: 'Was Sie bei uns erwartet:',
        1: 'Spannende Herausforderungen rund um IT',
        2: 'Flache Hierarchien',
        3: 'Gutes Betriebsklima',
        4: 'Zukunftssicherer, unbefristeter Arbeitsplatz',
        5: 'Freiraum und selbstbestimmtes Arbeiten',
        6: 'Attraktives Gehalt mit vielen Zusatzleistungen',
        7: 'Flexible Arbeitszeiten',
      },
      apprentice: {
        title: 'Wir bilden aus',
        a: 'bringe ist ein IHK-Ausbildungsbetrieb für Fachinformatiker in den Fachrichtungen Anwendungsentwicklung und Systemintegration.',
        b: 'Außerdem sind wir akkreditierter Partner der DHBW (Duale Hochschule Baden-Württemberg) im Fachbereich Wirtschaftsinformatik.',
        c: 'Wir begleiten Sie gerne bei Ihrem Start ins Berufsleben. Als Azubi erwartet Sie bei uns:',
        1: 'Persönliche Betreuung durch qualifizierte Fachausbilder',
        2: 'Aktive Integration ins Team',
        3: 'Mitarbeit an realen Projekten',
        4: 'Gute Übernahmechancen nach erfolgreichem Abschluss',
      }
    },
    en: {
      home: 'Home',
      services: 'Services',
      portfolio: 'Portfolio',
      about: 'About',
      references: 'References',
      contact: 'Contact',
      jobs: 'Jobs',
      title: 'Fully Integrated, One Stop IT Solutions',
      subtitle: 'Qualified 24/7 Support',
      hosting: {
        title: 'Managed Hosting',
        subtitle: 'From email to redundant HA cluster.',
        1: 'Cloud-based hosting/storage (VDI)',
        2: 'Physical/virtual + mixMode',
        3: 'Multisite HA cluster, active/active',
        4: ' Domain/DNS management, E-Mail',
      },
      support: {
        title: 'ITC services for SMB',
        subtitle: 'Tailored solutions and services, for small and medium-size companies.',
        1: 'Onsite integration',
        2: 'HW/SW upgrades & patching',
        3: 'Consulting',
        4: 'Client support',
      },
      development: {
        title: 'Web Development',
        subtitle: 'Custom software for custom business processes.',
        1: 'PHP, Laravel, Symfony',
        2: 'MySQL, PostgreSQL, MongoDB',
        3: 'JavaScript, Vue.js',
        4: 'HTML, CSS, Sass',
      },
      company: {
        1: 'bringe informationstechnik GmbH is an owner-operated company, founded in March 2000.',
        2: 'Based in Karlsruhe, we provide B2B solutions that simply fit your needs.',
        us: {
          title: 'What defines our company',
          1: 'ISP/ICT Systems integrator (own data centers)',
          2: 'ISO 27001/2013 certification',
          3: 'B2B solutions „Made in Germany“',
          4: 'Full compliance with German Bundesdatenschutzgesetz (=Federal data protection act)',
          5: '15 member strong team',
        },
        center: {
          title: 'Our data centers',
          1: 'Complete infrastructure management by bringe',
          2: 'Data center operation with several active sites',
          3: 'DC coupling over disjoint conncetions (> 150 G)',
          4: 'Redundant broadband internet connections (> 30 G)',
          5: 'Direct peering with several tier 1 providers',
        }
      },
      team: {
        title: 'Join the team',
        subtitle: 'Working at bringe:',
        1: 'Face exciting challenges around IT',
        2: 'Flat organization',
        3: 'Good working environment',
        4: 'Future proven and permanent employment',
        5: 'Workplace autonomy',
        6: 'Attractive salary package, including a number of benefits',
        7: 'Flexible working hours',
      },
      apprentice: {
        title: 'Apprenticing company',
        a: 'bringe is an IHK- (Chamber of Commerce and Industry) certified apprenticing company in the areas of sofware development and system integration.',
        b: 'We’re also a partner of DHBW (Duale Hochschule Baden-Württemberg/Baden-Württemberg Cooperative State University) in the field of Business Informatics.',
        c: 'Start your career with us, in a highly specialised, dedicated company offering plenty of opportunities:',
        1: 'Personal mentoring by qualified training supervisors',
        2: 'Full team integration from the start',
        3: 'Active participation in real projects',
        4: 'Good prospects for permanent employment after successful qualification',
      }
    },
  },
});
